module.exports = __webpack_public_path__ + "img/shipowner.eb483d32.png";